export type MedicalRecordSection =
  | "symptoms"
  | "diagnoses"
  | "medications"
  | "visits"
  | "vitals"
  | "providers";

export function buildRecordDetailPath(
  section: MedicalRecordSection,
  recordId: string,
  userId?: string
) {
  if (!recordId) return "";
  if (userId) {
    return `/medical-records/user/${userId}/${section}/${recordId}`;
  }
  return `/medical-records/${section}/${recordId}`;
}

export function pickRecordValue<T = string>(
  record: Record<string, any>,
  keys: string[]
): T | undefined {
  for (const key of keys) {
    if (key in record && record[key] !== undefined && record[key] !== null) {
      return record[key] as T;
    }
  }
  return undefined;
}
